import { useEffect } from "react";
import { Button } from "@telegram-apps/telegram-ui";

import { isMiniApp } from "../auth";
import { useWebChrome } from "../webChrome";

/**
 * Веб-фолбэк нативных кнопок Telegram: верхняя «Назад» и нижняя главная кнопка.
 * В Mini App ничего не рисует (там их показывает сам Telegram).
 */
export function WebChrome() {
  const chrome = useWebChrome();
  const backVisible = !isMiniApp() && !!chrome?.back?.visible;
  const mainVisible = !isMiniApp() && !!chrome?.main?.visible;

  useEffect(() => {
    document.body.dataset.webBack = backVisible ? "1" : "";
    return () => {
      document.body.dataset.webBack = "";
    };
  }, [backVisible]);

  useEffect(() => {
    document.body.dataset.webMain = mainVisible ? "1" : "";
    return () => {
      document.body.dataset.webMain = "";
    };
  }, [mainVisible]);

  if (isMiniApp() || !chrome) return null;
  const { main, back } = chrome;

  return (
    <>
      {back?.visible && (
        <div className="web-topbar">
          <button type="button" className="web-back" onClick={back.onClick}>
            ← Назад
          </button>
        </div>
      )}
      {main?.visible && (
        <div className="web-mainbar">
          <Button
            size="l"
            stretched
            disabled={!main.enabled}
            loading={main.loading}
            onClick={main.onClick}
          >
            {main.text}
          </Button>
        </div>
      )}
    </>
  );
}
